import {
    ODataHeader,
    ODataString,
    ODataBoolean,
    ODataInteger
} from "pbas-vue-components";
import { translate } from '../trans'
import store from '@/store'

const NewsHeaders = [
    new ODataHeader({
        title: "Id",
        type: new ODataString("Id"),
        visible: false,
        searchable: false,
        isIdentifier: true,
        allowVisibilityChange: false
    }),
    new ODataHeader({
        title: "PlanId",
        type: new ODataString("PlanId"),
        visible: false,
        searchable: false,
        isIdentifier: true,
        allowVisibilityChange: false
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Name"),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        title: "globals.type",
        type: new ODataString("Type/Translations[]/DisplayValue", {
            getString: item => {
                if (!item) return "";
                const lang = store.getters['common/language']
                return translate(item.Type, lang.language);
            }
        }),
        sortable: true,
        visible: true,
        searchable: true,
        orderByKey: "Type/Name"
    }),
    new ODataHeader({
        title: "globals.priority",
        type: new ODataInteger("Order"),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        title: "headers.news.seconds",
        type: new ODataInteger("Seconds"),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        title: "globals.active",
        type: new ODataBoolean("Active"),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        type: new ODataString("Type/Id"),
        visible: false,
        allowVisibilityChange: false,
    }),
    new ODataHeader({
        type: new ODataString("Type/Name"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        type: new ODataString("Type/Translations[]/LanguageCode"),
        visible: false,
        allowVisibilityChange: false
    }),

    new ODataHeader({
        type: new ODataString("Translations[]/Id"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        type: new ODataString("Translations[]/Html"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        type: new ODataString("Translations[]/LanguageCode"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        type: new ODataString("Translations[]/Image/PhysicalFile/"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        type: new ODataString("Translations[]/ImageLink"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
        version:2
    })
];
export default NewsHeaders;